// extracted by mini-css-extract-plugin
export default {"video":"Video_video__520Pd","qmeta":"Video_qmeta__MiFdK"};